/* Hide empty variants */
(() => {
  const selectorsToWatch = [
    'data-option-available',
    'aria-disabled',
    'disabled',
    'data-current-checked',
    'checked'
  ];

  function isUnavailable(input) {
    return (
      input.getAttribute('data-option-available') === 'false' ||
      input.getAttribute('aria-disabled') === 'true' ||
      input.disabled === true
    );
  }

  function initVariantHider(picker) {
    if (!picker || picker.__variantHiderInit) return;
    picker.__variantHiderInit = true;

    let pending = false, raf1 = 0, raf2 = 0;

    const updateAllFieldsets = () => {
      picker.querySelectorAll('fieldset.variant-option').forEach(updateFieldset);
    };

    const updateFieldset = (fieldset) => {
      const labels = Array.from(fieldset.querySelectorAll('.variant-option__button-label'));
      labels.forEach((label) => {
        const input = label.querySelector('input[type="radio"]');
        if (!input) return;
        label.classList.toggle('is-hidden', isUnavailable(input));
      });

      const checked = fieldset.querySelector('input[type="radio"]:checked');
      const checkedHidden = checked && checked.closest('.variant-option__button-label')?.classList.contains('is-hidden');

      if (!checked || checkedHidden) {
        const firstAvailable = fieldset.querySelector('.variant-option__button-label:not(.is-hidden) input[type="radio"]');
        if (firstAvailable && firstAvailable !== checked) {
          if (picker.__pickingGuard) return;
          picker.__pickingGuard = true;
          firstAvailable.checked = true;
          firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
          picker.__pickingGuard = false;
        }
      }
    };

    const scheduleUpdate = () => {
      if (pending) return;
      pending = true;
      picker.setAttribute('data-state', 'updating');
      Promise.resolve().then(() => {
        raf1 = requestAnimationFrame(() => {
          raf2 = requestAnimationFrame(() => {
            updateAllFieldsets();
            pending = false;
            picker.removeAttribute('data-state');
          });
        });
      });
    };

    picker.addEventListener('change', scheduleUpdate);
    picker.addEventListener('input', scheduleUpdate);

    picker.addEventListener('pointerdown', (e) => {
      const label = e.target && (e.target.closest && e.target.closest('.variant-option__button-label'));
      if (!label) return;
      const input = label.querySelector('input[type="radio"]');
      if (!input) return;
      if (isUnavailable(input) || label.classList.contains('is-hidden')) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'childList') { scheduleUpdate(); return; }
        if (m.type === 'attributes' && selectorsToWatch.includes(m.attributeName)) { scheduleUpdate(); return; }
      }
    });
    mo.observe(picker, { subtree: true, childList: true, attributes: true });

    updateAllFieldsets();
  }

  function boot() {
    document.querySelectorAll('variant-picker').forEach(initVariantHider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', boot);
})();

/* Animations */
(() => {
  let io;

  function getObserver() {
    if (io) return io;
    if (!('IntersectionObserver' in window)) return null;
    io = new IntersectionObserver((entries, obs) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          obs.unobserve(entry.target);
        }
      }
    }, { root: null, rootMargin: '0px 0px -5% 0px', threshold: 0.1 });
    return io;
  }

  const SELECTORS = [
    'main .h1', 'main .h2', 'main .h3', 'main .h4', 'main .h5', 'main .h6',
    'main h1', 'main h2', 'main h3', 'main h4', 'main h5', 'main h6',
    'main .rte-formatter p', 'main rte-formatter p', 'main rte-formatter ul', 'main rte-formatter ol',
    'main a.button', 'main a.button-secondary', 'main a.link',
    'main accordion-custom details',
    '.product-information product-price',
    '.product-information .buy-buttons-block',
    '.large-logo img',
    'main .text-block.h1', 'main .text-block.h2', 'main .text-block.h3',
    'main .text-block.h4', 'main .text-block.h5', 'main .text-block.h6',
    '.resource-list',
    '.product-grid',
    '.search-page-input__parent',
    '.icon-block__media',
    '.variant-picker',
    '.image-block',
    '.media-block__media',
    '.email-signup__input-group'
  ];

  function observeCurrentTargets() {
    const obs = getObserver();
    if (!obs) return;
    const selector = SELECTORS.join(',');
    document.querySelectorAll(selector).forEach(el => {
      if (!el.classList.contains('in-view')) obs.observe(el);
    });
  }

  function init() {
    observeCurrentTargets();
    const main = document.querySelector('main');
    if (main) {
      const mo = new MutationObserver((muts) => {
        for (const mut of muts) {
          if (mut.addedNodes && mut.addedNodes.length) {
            observeCurrentTargets();
            break;
          }
        }
      });
      mo.observe(main, { childList: true, subtree: true });
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
  document.addEventListener('shopify:section:reorder', init);
  document.addEventListener('page:load', init);
  document.addEventListener('load', init);
  setTimeout(init, 350);
})();